import enGB from './en-GB';
import enUS from './en-US';
import frFR from './fr-FR';
// import es from './es';
// import it from './it';
// import de from './de';
// import fil from './fil';

export default {
	'en-GB': enGB,
	'en-US': enUS,
	'fr-FR': frFR,
	// es,
	// it,
	// de,
	// fil,
};
